import React from 'react';
import { Box, Typography } from '@mui/material';

import { CountryFlag } from 'components/common/CountryFlag/CountryFlag';

interface IPersonHeadingProps {
  name: string;
  country?: string;
  subtitle: string;
  mark?: React.ReactNode;
  variant?: 'page' | 'drawer';
}

export const PersonHeading: React.FC<IPersonHeadingProps> = ({
  name,
  country,
  subtitle,
  mark,
  variant = 'page',
}) => {
  const isDrawer = variant === 'drawer';

  return (
    <Box minWidth={0} flexGrow={isDrawer ? 1 : undefined}>
      <Typography
        variant={isDrawer ? 'h3' : 'h2'}
        component="h2"
        display="flex"
        flexWrap={isDrawer ? 'nowrap' : 'wrap'}
        alignItems="center"
        gap={1}
      >
        <CountryFlag
          country={country}
          width={20}
          sx={{ marginRight: 0, display: 'flex' }}
        />
        <Typography
          component="span"
          variant="inherit"
          minWidth={0}
          noWrap={isDrawer}
        >
          {name}
        </Typography>
        {mark}
      </Typography>
      {Boolean(subtitle) && (
        <Typography
          variant={isDrawer ? 'caption' : 'body1'}
          component="p"
          color="text.secondary"
          noWrap={isDrawer}
          mt={isDrawer ? 0.25 : 0}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
